import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Provider } from 'mobx-react';
import EventListener, { withOptions } from 'react-event-listener';
import { observer, inject } from 'mobx-react';

import Home from './Home.js';
import About from './About.js';
import Videos from './Videos.js';

import './App.css';
import Navigation from './Navigation.js';
import Footer from './Footer.js';
import ScrollToTop from './ScrollToTop.js';

@inject('appState')
@observer
class App extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.updateOrientation = this.updateOrientation.bind(this)
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    document
      .querySelector('.App')
      .addEventListener('scroll', this.handleScroll);
    this.updateWindowDimensions();
    window.addEventListener(
      'orientationchange',
      this.updateOrientation.bind(this)
    );
    window.addEventListener('resize', this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener(
      'orientationchange',
      this.updateOrientation.bind(this)
    );
    window.removeEventListener(
      'resize',
      this.updateWindowDimensions.bind(this)
    );
  }

  handleScroll(e) {
    this.props.appState.updateYOffset(window.pageYOffset);
  }

  updateOrientation() {
    this.updateWindowDimensions();
  }

  updateWindowDimensions() {
    this.props.appState.updateWindowDimensions(window.innerWidth, window.innerHeight);
  }

  render() {
    return (
      <Provider appState={this.props.appState}>
        <Router>
          <ScrollToTop>
            <div className="App">
              <EventListener
                target="window"
                onResize={this.handleResize}
                onScroll={withOptions(this.handleScroll, {
                  passive: true,
                  capture: false
                })}
              />
              <Navigation offset={this.props.appState.pageYOffset} />
              <Route
                exact
                path="/"
                component={Home}
                appState={this.props.appState}
              />
              <Route path="/about" component={About} />
              <Route path="/videos" component={Videos} />
              <Footer />
            </div>
          </ScrollToTop>
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js